import { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import DashboardPeriodoComercial from "./DashboardPeriodoComercial";
import DashboardOportunidades from "./DashboardOportunidades";
import DashboardCreditos from "./DashboardCreditos";
import DashboardSuscripciones from "./DashboardSuscripciones";
import DashboardClientesFrecuentes from "./DashboardClientesFrecuentes";
import MapClientes from "./MapClientes";
import DashboardResumen from "./DashboardResumen";
import SectionHeader from "./ui/SectionHeader";
import { useSubscriptionMetrics } from "./subscriptions/hooks";
export default function DashboardCRM({ store, onOpenConfig, onGoCreditos, onboardingTarget }) {
  const [tab, setTab] = useState("resultados");
  useEffect(() => { if (onboardingTarget === "onb-mapa-clientes") setTab("clientes"); else if (onboardingTarget === "onb-funnel" || onboardingTarget === "onb-rendimiento") setTab("resultados"); }, [onboardingTarget]);
  const subs = useSubscriptionMetrics(store);
  return <Box><SectionHeader component="h2" title="Reportes" description="Detecta qué funciona y dónde actuar." sx={{ mb: 2 }} />
    <Tabs value={tab} onChange={(_, value) => setTab(value)} aria-label="Secciones de reportes" sx={{ mb: 3 }}><Tab value="resultados" label="Resultados" /><Tab value="seguimiento" label="Seguimiento" /><Tab value="clientes" label="Clientes" /></Tabs>
    {tab === "resultados" && <DashboardPeriodoComercial store={store} />}
    {tab === "seguimiento" && <><DashboardOportunidades store={store} /><DashboardCreditos store={store} onGoCreditos={onGoCreditos} /><DashboardSuscripciones store={store} subs={subs} onOpenConfig={onOpenConfig} /><DashboardResumen store={store} /></>}
    {tab === "clientes" && <><MapClientes store={store} /><DashboardClientesFrecuentes store={store} /></>}
  </Box>;
}
